<template>
  <transition name="fade">
    <div v-if="visible" class="modal-overlay d-flex align-items-center justify-content-center">

      <div class="modal-box text-center">
        <div class="icon-container">
          <i class="fa fa-exclamation-circle icon-alert" aria-hidden="true"></i>
        </div>
                  <h3 class="modal-title">{{ title }}</h3>
        <p class="modal-message" v-html="message"></p>
        <p v-if="subMessage" class="modal-sub-message" v-html="subMessage"></p>
        <button class="btn btn-danger btn-sm mt-3 px-4" @click="$emit('close')">
                {{ closeText }}
         </button>
      </div>
    </div>
  </transition>
</template>



<script setup>
defineProps({
  visible: Boolean,
  title: String,
  message: String,
  subMessage: String,
  closeText: {
    type: String,
    default: 'Close'
  }
});
</script>

<style scoped>

.modal-title {
  font-size: 20px;
  font-weight: bold;
  color: #dc3545; /* Bootstrap red */
}

.modal-message {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.modal-sub-message {
  font-size: 14px;
  color: #666;
  margin-top: 10px;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9999;
}

.modal-box {
  background: #fff;
  padding: 30px 10px;
  border-radius: 16px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

p.modal-message{
  margin-bottom: unset;
}

.icon-container {
  font-size: 48px;
  color: #dc3545; /* Bootstrap red */
}

.modal-message {
  font-size: 14px;
  font-weight: 400;
  color: rgba(100, 116, 139, 1);
}

.modal-sub-message {
  font-size: 14px;
  color: rgba(100, 116, 139, 1);
  margin-top: 0px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

/* .fade-enter-active {
  animation: fadeInUp 0.4s ease;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
} */
</style>
